import { RmaIcons } from '@rma/generic/ui/icon';

export interface StatisticConfigOption {
  type: string;
  icon: RmaIcons;
  isCurrency: boolean;
}

export const StatisticConfig = [
  { type: 'reviews', icon: 'handshake', isCurrency: false },
  { type: 'avgOnMarket', icon: 'schedule', isCurrency: false },
  { type: 'forSale', icon: 'cottage', isCurrency: false },
  { type: 'sold', icon: 'gavel', isCurrency: false },
  { type: 'avgPrice', icon: 'payments', isCurrency: true },
  { type: 'totalPrice', icon: 'volcano', isCurrency: true },
] as const satisfies readonly StatisticConfigOption[];

export type StatisticType = (typeof StatisticConfig)[number]['type'];
